module.exports = __webpack_public_path__ + "img/8.296bb1fa.jpg";